import { Box, MenuItem, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";
import PermissionInfo from "../permissions/permissionInfo";

type ButtontMenuItemProps = {
  onClick?: any;
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  title: string;
  locked?: boolean;
  moduleLocked?: boolean;
  disabled?: boolean;
  module?: string;
  style?: any;
  textColor?:
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning"
    | "textPrimary"
    | "textSecondary"
    | "textDisabled"
    | string;
  handleOpenModuleDialog?: (name: string) => void;
};

const ButtonMenuItem = ({
  onClick,
  startIcon,
  endIcon,
  locked,
  moduleLocked,
  title,
  disabled,
  module,
  style = {},
  textColor,
  handleOpenModuleDialog,
  ...props
}: ButtontMenuItemProps) => {
  return (
    <MenuItem
      disabled={disabled}
      onClick={(e) => {
        if (!locked) {
          onClick?.(e);
        }
        if (moduleLocked) handleOpenModuleDialog?.(module ?? "");
      }}
      {...props}
    >
      <Box sx={{ "& svg": { mr: 2, width: 20, height: 20 } }}>{startIcon}</Box>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        <Typography
        >
          {title}
        </Typography>
        <Box
          sx={{
            ml: "auto",
          }}
        >
          {locked ? (
            <PermissionInfo moduleLocked={moduleLocked} style={style} />
          ) : (
            endIcon
          )}
        </Box>
      </Stack>
    </MenuItem>
  );
};
export default ButtonMenuItem;
